import React, { Component } from "react";
import "./App.css";
import { Config } from "./constant";
import ChatBody from "./chat/ChatBody";
import { send, getMessage } from "./Socket";
import FormBody from "./form/FormBody";
import { observer } from "mobx-react";
import { CommonStore } from "./Store";

export default observer(
  class App extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isSessionActive: false,
        showViewChat: false
      };
    }

    componentWillMount() {
      console.log("SESSION:JOIN", Config.domainId());
      if (localStorage.getItem(Config.domainId())) {
        this.setState({
          isSessionActive: true
        });
        let sessionJoin = JSON.stringify({
          code: "session:join",
          sessionId: localStorage.getItem(Config.domainId())
        });
        send(sessionJoin);
      } else {
        this.setState({
          isSessionActive: false
        });
      }
    }

    componentWillReceiveProps() {
      console.log("COMMON STORE PARENT", CommonStore.showViewChat);
    }

    componentDidMount() {
      const message = setInterval(getMessage(), 2);
    }

    handleChangeSessionActive = () => {
      this.setState({
        isSessionActive: true
      });
    };

    onClick = flag => {
      this.setState({
        showViewChat: flag
      });
    };

    onChangeSession = () => {
      this.setState({
        isSessionActive: true
      });
    };

    onClose = () => {
      window.parent.postMessage({ message: "close" }, "*");
      this.setState({
        showViewChat: false
      });
    };

    render() {
      const { isSessionActive, showViewChat } = this.state;
      return (
        <div>
          {isSessionActive ? (
            <ChatBody onClose={this.onClose} />
          ) : (
            <FormBody onChangeSession={this.handleChangeSessionActive} displayPicture={Config.displayPicture()} />
          )}
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/App.js